const storeData = [
  {
    img: process.env.PUBLIC_URL + "/img/img_store001.jpg",
    name: "둔촌보훈병원점",
    add: "서울 강동구 둔촌동 556",
    call: "02-478-5592",
    time: "pm 1:00 ~ am 1:00",
    delivery: true
  },
  {
    img: process.env.PUBLIC_URL + "/img/img_store002.jpg",
    name: "장안래미안점",
    add: "서울 동대문구 장한로32길 13",
    call: "02-2215-5592",
    time: "pm 3:00 ~ am 02:00",
    delivery: true
  },
  {
    img: process.env.PUBLIC_URL + "/img/img_store003.jpg",
    name: "답십리점",
    add: "서울 동대문구 한천로11길 15",
    call: "02-2217-3392",
    time: "pm 2:30 ~ am 1:30",
    delivery: true
  },
  {
    img: process.env.PUBLIC_URL + "/img/img_store004.jpg",
    name: "건대점",
    add: "서울 광진구 아차산로25길 8 ",
    call: "02-468-9992",
    time: "pm 5:00 ~ am 5:00",
    delivery: false
  },
  {
    img: process.env.PUBLIC_URL + "/img/img_store005.jpg",
    name: "군자점",
    add: "서울 광진구 능동로36길 25",
    call: "02-2201-9792",
    time: "am 11:00 ~ am 3:00",
    delivery: false
  },
  {
    img: process.env.PUBLIC_URL + "/img/img_store006.jpg",
    name: "부산 사직점",
    add: "부산 동래구 사직북로 26",
    call: "051-507-6692",
    time: "pm 3:00 ~ am 1:00",
    delivery: false
  },
];

export default storeData;